import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const clinicalSummaryApi = baseApi.injectEndpoints({
  tagTypes: ["ClinicalSummaryLogs"],
  endpoints: (builder) => ({
    getClinicalSummaryLogs: builder.query({
      query: (params) => {
        return {
          url: `/PatientClinicals/logs.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    getCcdFileUrl: builder.query({
      query: (params) => {
        return {
          url: `/PatientClinicals/get_file_name.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    searchProvidersEmail: builder.query({
      query: (params) => {
        return {
          url: `/providers/search_by_email.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    searchProviders: builder.query({
      query: (params) => {
        return {
          url: `/providers.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    shareClinicalDataViaMessage: builder.mutation({
      query: (params) => {
        return {
          url: `/PatientClinicals/send_message.json`,
          method: "POST",
          data: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    shareClinicalDataViaEmail: builder.mutation({
      query: (params) => {
        return {
          url: `/PatientClinicals/transmit_ccd.json`,
          method: "POST",
          body: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    downloadCcdFile: builder.query({
      query: (params) => {
        return {
          url: `/PatientClinicals/download_ccd.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetClinicalSummaryLogsQuery,
  useGetCcdFileUrlQuery,
  useSearchProvidersEmailQuery,
  useSearchProvidersQuery,
  useShareClinicalDataViaMessageMutation,
  useShareClinicalDataViaEmailMutation,
  useDownloadCcdFileQuery,
} = clinicalSummaryApi;
